import axios from 'axios'

const service = axios.create({
    withCredentials: true //这里是关键
}); // create :配置新建一个 axios 实例

export function upload(fileobj, url, token) {
    let param = new FormData();
    param.append("file", fileobj.file);
    console.log('formdata->', param)
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": token
        }
    };
    return service.post(url, param, config);
}

// tinymce 上传图片
export function uploadTin(blobInfo, url, token) {
    console.log('文件信息->', blobInfo.blob())
    console.log('文件大小->', blobInfo.blob().size)
    console.log('文件格式->', blobInfo.blob().type)
    console.log('文件名称->', blobInfo.filename())
    const formData = new FormData()
    // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
    // formData.append('file', img)
    formData.append('file', blobInfo.blob())
    formData.append('name', blobInfo.filename())
    console.log('formdata->', formData)
    console.log(formData.get('file'));
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": token
        }
    };
    return service.post(url, formData, config);
}


// tinymce 上传所有文件
export function uploadFile(file, url, token,filetype) {
    const formData = new FormData()
    // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
    // formData.append('file', img)
    formData.append('file', file)
    formData.append('filetype', filetype)
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": token
        }
    };
    return service.post(url, formData, config);
}

